import { noop } from "angular";

import type { IProfileService } from "App/Modules/Auth";

import type { IModalService } from "App/Modules/Services";

import type { IProfile } from "../../../../Models";

export default class ProfileUserInformationComponentController {
    public static $inject = ["mmProfileService", "mmModalService"];

    public profile: IProfile;

    public subCaption = "";

    constructor(private profileService: IProfileService, private readonly modalService: IModalService) {}

    public $onChanges(): void {
        this.subCaption = "";

        if (this.profile) {
            this.subCaption = this.profile.email;

            if (this.profile.phoneNumber) {
                this.subCaption += ` | ${this.profile.phoneNumber}`;
            }

            if (this.profile.smsNumber) {
                this.subCaption += ` | ${this.profile.smsNumber}`;
            }
        }
    }

    public editUserInformation() {
        this.modalService.open("mmProfileUserInformationEdit", this.profile).subscribe(
            (profile) => {
                this.profile = profile;
                this.$onChanges();
            },
            () => noop,
        );
    }
}
